import React from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { loginSliceValue } from '../../redux/reducers/loginSlice';
import { INoteReq, IPatientRes } from './index.type';

const useUpdateNote = ({ patientId }: { patientId?: string }) => {
  const { userDetails } = useSelector(loginSliceValue);
  const [updateNoteLoading, setUpdateNoteLoading] = React.useState(false);

  const updateNote = async (formData: INoteReq & { _id: string }) => {
    setUpdateNoteLoading(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_URL}/rtm/note?patientId=${patientId}&id=${formData._id}`,
        method: 'PUT',
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + userDetails.token,
        },
      });

      if (response.data?.status === 'success') {
        toast.success('Note updated successfully');
        return response.data;
      }

      toast.error('Failed to update note. Please try again.');
      return { status: 'fail' };
    } catch (error: any) {
      toast.error(error?.msg || 'Failed to update note. Please try again.');
      return { status: 'fail' };
    } finally {
      setUpdateNoteLoading(false);
    }
  };

  return {
    updateNoteLoading,
    updateNote,
  };
};

export default useUpdateNote; 